module.exports = __webpack_public_path__ + "img/57_14.c1569036.png";